var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,0,0)",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.75 6.375L9 11.625L14.25 6.375",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };